import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function MobileStickyCtaBar() {
  return <section id="mobile-sticky-cta-bar" className="fixed right-0 bottom-0 left-0 z-50 border-t border-background/10 bg-foreground p-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] shadow-lg md:hidden">
      <div className="mx-auto flex max-w-md items-center gap-3">
        <Button asChild aria-label="Call Gold Garage Door" className="h-12 flex-1 rounded-lg bg-accent text-base font-bold text-accent-foreground shadow-md hover:bg-accent/90">
          <Link to="tel:0485000933">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 size-5" aria-hidden="true">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            Call Now
          </Link>
        </Button>
        <Button asChild aria-label="Message Gold Garage Door on WhatsApp" className="h-12 flex-1 rounded-lg bg-chart-3 text-base font-bold text-primary-foreground shadow-md hover:bg-chart-3/90">
          <Link to="https://wa.me/61485000933" newTab>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 size-5" aria-hidden="true">
              <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
            </svg>
            WhatsApp
          </Link>
        </Button>
      </div>
    </section>;
}